import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { Button, Icon } from '@haldor/ui';
import './GenerateBaseGroupsRandomly.scss';

var GenerateBaseGroupsRandomly = /*#__PURE__*/function (_Component) {
  _inherits(GenerateBaseGroupsRandomly, _Component);

  var _super = _createSuper(GenerateBaseGroupsRandomly);

  function GenerateBaseGroupsRandomly(props) {
    var _this;

    _classCallCheck(this, GenerateBaseGroupsRandomly);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setType", function (event) {
      return _this.setState({
        type: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAmount", function (event) {
      return _this.setState({
        amount: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "subtractAmount", function (event) {
      return _this.setState({
        amount: parseInt(_this.state.amount) - 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addAmount", function (event) {
      return _this.setState({
        amount: parseInt(_this.state.amount) + 1
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onReset", function () {
      _this.setState({
        amount: 0,
        type: 'number-of-groups'
      });

      if (_this.props.onSubmit != null) {
        _this.props.onSubmit([]);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (e) {
      if (e != null) {
        e.preventDefault();
      }

      var units = [];

      var students = _toConsumableArray(_this.props.students);

      if (_this.state.amount < 1) {
        return false;
      }

      if (_this.state.type == 'number-of-groups') {
        var studentsPerUnit = Math.ceil(students.length / _this.state.amount);

        while (units.length < _this.state.amount) {
          var unitStudents = [];

          while (unitStudents.length < studentsPerUnit && students.length > 0) {
            var index = Math.floor(Math.random() * students.length);
            unitStudents.push({
              userId: students[index].id,
              user: students[index]
            });
            students.splice(index, 1);
          }

          units.push({
            title: _this.props.translate('group') + ' ' + (units.length + 1),
            memberships: unitStudents
          });
        }
      } else if (_this.state.type == 'students-per-group') {
        var numberOfUnits = Math.ceil(students.length / _this.state.amount);

        while (units.length < numberOfUnits) {
          var _unitStudents = [];

          while (_unitStudents.length < _this.state.amount && students.length > 0) {
            var _index = Math.floor(Math.random() * students.length);

            _unitStudents.push({
              userId: students[_index].id,
              user: students[_index]
            });

            students.splice(_index, 1);
          }

          units.push({
            title: _this.props.translate('group') + ' ' + (units.length + 1),
            memberships: _unitStudents
          });
        }
      }

      if (_this.props.onSubmit != null) {
        _this.props.onSubmit(units);
      }
    });

    _this.state = {
      type: 'number-of-groups',
      amount: 0
    };
    return _this;
  }

  _createClass(GenerateBaseGroupsRandomly, [{
    key: "render",
    value: function render() {
      var types = [{
        value: 'number-of-groups',
        label: this.props.translate('number-of-groups')
      }, {
        value: 'students-per-group',
        label: this.props.translate('students-per-group')
      }];
      return /*#__PURE__*/React.createElement("div", {
        className: "basegroups generate"
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.type,
        onChange: this.setType
      }, types.map(function (type) {
        return /*#__PURE__*/React.createElement("option", {
          key: type.value,
          value: type.value
        }, type.label);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "number-input"
      }, /*#__PURE__*/React.createElement("span", {
        className: "calc subtract",
        onClick: this.subtractAmount
      }, "-"), /*#__PURE__*/React.createElement("input", {
        type: "number",
        value: this.state.amount,
        onChange: this.setAmount,
        min: "0",
        max: "99"
      }), /*#__PURE__*/React.createElement("span", {
        className: "calc add",
        onClick: this.addAmount
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onSubmit
      }, this.props.translate('generate'))));
    }
  }]);

  return GenerateBaseGroupsRandomly;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(GenerateBaseGroupsRandomly);